import "./list_field.css";
import { Controller as BaseController } from "@hotwired/stimulus";

const COUNTER_INTERVAL = 750;

export class Controller extends BaseController {
  static targets = ["textarea", "counter"];

  initialize() {
    this._updateCounterTimer = null;
    this.counter = 0;
    this.updateCounter();
  }

  /* Events */
  onKeyup(event) {
    if (event.which > 32 && event.which < 45) return;

    if (this._updateCounterTimer == null) {
      this._updateCounterTimer = setTimeout(() => {
        this.updateCounter();
        clearTimeout(this._updateCounterTimer);
        this._updateCounterTimer = null;
      }, COUNTER_INTERVAL);
    }
  }

  onSubmit() {
    // NOTE: Do we want to block submission for a specific condition? Otherwise replace action with trimLines directly
    this.trimLines();
  }

  /* Methods */
  trimLines() {
    const value = this.textareaTarget.value;
    this.textareaTarget.value = value
      .split("\n")
      .map((line) => line.trim().replace(/\s+/g, " "))
      .join("\n");
  }

  updateCounter() {
    this.counter = this.textareaTarget.value.split(/\r|\r\n|\n/).length;
    this.counterTarget.textContent = this.counter;
  }
}

/**
 Aglaoapis sparsepunctata Le Divelec, 2024 1078452
  Osmia cornuta (Latreille, 1805) 53176
 Lasioglossum     politum 239875
           Nomada moeschleri Alfken, 1913 318302
  Hylaeus       alpinus 239759
  Noti findi (asd Latreille, 1805) xxx
 */
